<app-menu-item-header headerName="Restaurant Gallery" headerComment="An Authentic Bengali Recipe"></app-menu-item-header>



<owl-carousel-o [options]="customOptions">

  @for (slide of slidesStore; track slide) {
    <ng-template carouselSlide>
      <div class="slide">
        <img [src]="slide.src" [title]="slide.title" [alt]="slide.title || ''" style="padding: 10px;">
      </div>
    </ng-template>
  }

</owl-carousel-o>



